<template>
  <BreadCrumb PageTitle="Events" />
  <KanbanContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import KanbanContent from "../../template-components/Events/EventsGrid/EventsGrid.vue";

export default defineComponent({
  name: "EventsGridPage",
  components: {
    BreadCrumb,
    KanbanContent,
  },
});
</script>